"use client";

import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  buildAmazonSearchUrl,
  normalizeAmazonAssociateTag,
} from "@/lib/designer/amazonSearch";
import { trackEvent } from "@/utils/analytics";

export default function GalleryAmazonLink({
  searchTerms,
  placement,
}: {
  searchTerms: string;
  placement:
    | "gallery_grid"
    | "gallery_detail"
    | "gallery_related"
    | "ticket_detail";
}) {
  const associateTag = normalizeAmazonAssociateTag(
    process.env.NEXT_PUBLIC_AMAZON_ASSOCIATE_TAG
  );
  const searchUrl = buildAmazonSearchUrl(searchTerms, associateTag);
  if (!searchUrl) return null;

  return (
    <div className="mt-2">
      <Button
        asChild
        variant="outline"
        size="sm"
        className="h-auto min-h-14 w-full gap-1.5 rounded-lg px-2 py-2 text-center text-xs font-medium leading-snug whitespace-normal shadow-none sm:text-sm"
      >
        <a
          href={searchUrl}
          target="_blank"
          rel={
            associateTag
              ? "sponsored noopener noreferrer"
              : "noopener noreferrer"
          }
          title="Search Amazon for similar dresses using this design’s details. Results may vary."
          onClick={() => {
            trackEvent("similar_search_click", {
              retailer: "amazon",
              source: placement === "ticket_detail" ? "ticket" : "gallery",
              placement,
            });
          }}
        >
          <span>
            Similar on Amazon
            {associateTag ? (
              <span className="block text-[11px] font-normal sm:text-xs">
                (affiliate link)
              </span>
            ) : null}
          </span>
          <ExternalLink
            className="hidden size-3.5 shrink-0 sm:block"
            aria-hidden="true"
          />
          <span className="sr-only"> (opens in a new tab)</span>
        </a>
      </Button>
    </div>
  );
}
